import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ItemBoostMode extends Cloneable {

    static DISABLED = new ItemBoostMode(0, "DISABLED");
    static ITEM_AMOUNT = new ItemBoostMode(1, "ITEM_AMOUNT");
    static ITEM_POINTS = new ItemBoostMode(2, "ITEM_POINTS");

    static _values = [this.DISABLED, this.ITEM_AMOUNT, this.ITEM_POINTS];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ItemBoostMode.getValue(id));
        });
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof ItemBoostMode) {
            return ItemBoostMode._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "DISABLED") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof ItemBoostMode) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemBoostMode());
        } else if (target instanceof ItemBoostMode) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemBoostMode, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});